import { render } from "./PopupLocDuLieu.vue?vue&type=template&id=6ac36665&scoped=true"
import script from "./PopupLocDuLieu.vue?vue&type=script&lang=js"
export * from "./PopupLocDuLieu.vue?vue&type=script&lang=js"

import "./PopupLocDuLieu.vue?vue&type=style&index=0&id=6ac36665&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac36665"]])

export default __exports__